import DowntimeDollarsBar from './DowntimeDollarsBar';
import './DowntimeDollarsBar.css';
import { connect } from 'react-redux';

// Redux
const mapStateToProps = (state) => {
  return {
    bufferAmount: state.loyalty.bufferAmount,
    goalAmount: state.loyalty.goalAmount,
  };
}

const ConnectedDowntimeDollarsBar = connect(
  mapStateToProps
)(DowntimeDollarsBar);

export default ConnectedDowntimeDollarsBar;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/containers/DowntimeDollarsBar/index.js